import gql from "graphql-tag";

export default gql`
  mutation createInquiry(
    $listingId: ID!
    $collectionId: ID
    $checkInDate: String!
    $checkOutDate: String!
    $promoCodes: [String!]!
    $guestNb: Int
    $referralPartnerId: String
  ) {
    createInquiry(
      listingId: $listingId
      collectionId: $collectionId
      checkInDate: $checkInDate
      checkOutDate: $checkOutDate
      promoCodes: $promoCodes
      guestNb: $guestNb
      referralPartnerId: $referralPartnerId
    ) {
      payPath
      id
      uniqKey
      trackingInfo
    }
  }
`;
